import React, { useState } from 'react'
import { Box, Chip, makeStyles, Theme } from '@material-ui/core'

import { OffersTab } from './OffersTab'
import { SequencesTab } from './SequencesTab'
import { SettingsTab } from './SettingsTab'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    viewToggle: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
    },
}))

interface RenewalsHomeProps {
    readOnly?: boolean
    leasingSeasonId?: number
}

export const RenewalsHome: React.FC<RenewalsHomeProps> = ({
    readOnly = false,
    leasingSeasonId,
}) => {
    const classes = useStyles()
    const [subTab, setSubTab] = useState<'offers' | 'sequences' | 'settings'>(
        'offers',
    )

    return (
        <Box className={classes.root}>
            <Box className={classes.viewToggle}>
                <Chip
                    label="Offers"
                    size="small"
                    clickable
                    color={subTab === 'offers' ? 'primary' : 'default'}
                    onClick={() => setSubTab('offers')}
                    style={{ fontWeight: 600 }}
                />
                <Chip
                    label="Sequences"
                    size="small"
                    clickable
                    color={subTab === 'sequences' ? 'primary' : 'default'}
                    onClick={() => setSubTab('sequences')}
                    style={{ fontWeight: 600 }}
                />
                <Chip
                    label="Settings"
                    size="small"
                    clickable
                    color={subTab === 'settings' ? 'primary' : 'default'}
                    onClick={() => setSubTab('settings')}
                    style={{ fontWeight: 600 }}
                />
            </Box>

            {subTab === 'offers' && (
                <OffersTab
                    readOnly={readOnly}
                    leasingSeasonId={leasingSeasonId}
                />
            )}
            {subTab === 'sequences' && (
                <SequencesTab
                    readOnly={readOnly}
                    leasingSeasonId={leasingSeasonId}
                />
            )}
            {subTab === 'settings' && <SettingsTab readOnly={readOnly} />}
        </Box>
    )
}
